module.exports = __webpack_public_path__ + "Roboto-700.43183beef21370d8a4b0.woff";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.woff
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-700/Roboto-700.woff
// module chunks = main styles